module.exports = __webpack_public_path__ + "static/media/gptDataCode.72f3d7af.mp4";